import accordionEduc from "./accordionEduc.js";
import { isotopeInit } from "./massonryComponent.js";
import { newsletterForm } from "./newsletterForm.js";
import { openCloseMenu } from "./open-close-menu.js";
import { fromDown, staggerfromDown } from "./revealAnimations.js";
import { slider, sliders } from "./sliders.js";
import { stickySwipperComponent } from "./stickySwipperComponent.js";
import { gsap } from "gsap/dist/gsap";    
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import Swiper from "swiper";
import { Navigation, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { InitLoadMoreBlogs, InitTipsLoadMore, InitQaLoadMore } from "./searcher.js";


var tipsListPage = document.querySelectorAll(".educationaltipslist"); 
if (tipsListPage) {
    InitTipsLoadMore();
}


var blosgListPage = document.querySelectorAll(".bloglist");
if (blosgListPage) {
    InitLoadMoreBlogs();
}


var qaListPage = document.querySelectorAll(".educationalqalist");
if (qaListPage) {
    InitQaLoadMore();
}



gsap.registerPlugin(ScrollTrigger);

openCloseMenu();

// const stickySlider = document.querySelector(".slider-container");
const cards = document.querySelectorAll(".slider-container .themedCard");
cards.length > 1 && stickySwipperComponent();

// Animation for entering the page
const fromDownSelector = document.querySelectorAll(".fromDown");
fromDownSelector.forEach((elem) => {
  fromDown(elem, 0.7);
});

// Animation for staggered elements
const staggerArticle = document.querySelectorAll(".staggerArticle section");
staggerArticle.forEach((elem) => {
  staggerfromDown(elem, elem.querySelectorAll(".staggerfromDown"), 0.7);
});

const animatedGrid = document.querySelectorAll(".animatedGrid");
animatedGrid.forEach((elem) => {
    staggerfromDown(elem, elem.querySelectorAll(".staggerfromDown"), 0.7);  
});

const threeColumnSlider = sliders(".threeSlidesSlider", {
  slidesPerView: "auto",
  spaceBetween: 17,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    // when window width is >= 480px
    768: {
      slidesPerView: 2,
    },
    // when window width is >= 640px
    1280: {
      slidesPerView: 3
    },
  },
});

export const singleSlider = document.querySelectorAll(".singleSliderContainer");

singleSlider.forEach((slider) => {
  const sliderEl = slider.querySelector('.singleSlider');
  const swiper = new Swiper(sliderEl, {
    modules: [Navigation, Pagination, EffectFade],
    slidesPerView: 1,
    navigation: {
      nextEl: slider.querySelector(".swiper-custom-button-next"),
      prevEl: slider.querySelector(".swiper-custom-button-prev"),
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});

document.querySelectorAll(".customNavsContainer").forEach((container) => {
  const nextBtn = container.querySelector(".swiper-custom-button-next");
  const prevBtn = container.querySelector(".swiper-custom-button-prev");

  slider(container.querySelector('.threeColsSlider'), {
    slidesPerView: "auto",
    spaceBetween: 17,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: nextBtn && prevBtn ? {
      nextEl: nextBtn,
      prevEl: prevBtn,
    } : false, // Disable navigation if buttons are missing
    breakpoints: {
      768: { slidesPerView: 2,
        pagination: false
       },
      1280: { slidesPerView: 3,
        pagination: false
       },
    },
  });
})

// const productSlider = sliders(".productSlider", {
//   slidesPerView: 1,
//   // navigation: {
//   //   nextEl: ".swiper-custom-button-next",
//   //   prevEl: ".swiper-custom-button-prev",
//   // },
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
// });
// const customNext = document.querySelector(".swiper-custom-button-next");
// const customPrev = document.querySelector(".swiper-custom-button-prev");
// customNext && customNext.addEventListener("click", () => productSlider[0].slideNext());
// customPrev && customPrev.addEventListener("click", () => productSlider[0].slidePrev());

const question = document.querySelector(".question");
// question && isotopeInit()

export let isotop = null; 
if (question) {
    isotop = isotopeInit();
}


const accordions = document.querySelectorAll('[data-js="accordionEduc"]');
accordions.forEach((elem, index) => {
  // Initialize all accordions
  accordionEduc(elem, true);
  elem
    .querySelector('[data-js="accordion-trigger"]')
    .addEventListener("click", () => {
      setTimeout(() => {
        isotop && isotop.layout();
        ScrollTrigger.refresh();
      }, 300);
    });
});

function handleResize() {
  const triggers = document.querySelectorAll('.mobAccords [data-js="accordion-trigger"]');

  if (window.innerWidth >= 1024) {
    triggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'true');
      const panel = trigger.nextElementSibling; // Assuming the panel is the next sibling
      if (panel && panel.dataset.js === 'accordion_panel') {
        panel.style.maxHeight = panel.scrollHeight + "px"; // Ensure panels are expanded
      }
    });
  } else {
    triggers.forEach(trigger => {
      trigger.setAttribute('aria-expanded', 'false');
      const panel = trigger.nextElementSibling;
      if (panel && panel.dataset.js === 'accordion_panel') {
        panel.style.maxHeight = null; // Collapse panels
      }
    });
  }
}

// Add the event listener for window resize
window.addEventListener('resize', handleResize);

// Run the function once to initialize on page load
handleResize();




// NEWSLETTER 
const newsletterFormElement = document.querySelector("#newsletterForm");
newsletterFormElement && newsletterForm();


// FEEDBACK BUTTONS
const likeButton = document.getElementById("like-button");
const dislikeButton = document.getElementById("dislike-button");

// Get the current article URL (without query params)
const articleKey = `feedback-${window.location.pathname}`;

function saveFeedback(choice) {
  localStorage.setItem(articleKey, choice);
}

function loadFeedback() {
  const savedChoice = localStorage.getItem(articleKey);

  if (savedChoice === "like") {
    likeButton && likeButton.setAttribute("aria-pressed", "true");
    dislikeButton && dislikeButton.setAttribute("aria-pressed", "false");
  } else if (savedChoice === "dislike") {
    dislikeButton && dislikeButton.setAttribute("aria-pressed", "true");
    likeButton && likeButton.setAttribute("aria-pressed", "false");
  }
}

function handleFeedbackClick(clickedButton, otherButton, choice) {
  const isPressed = clickedButton.getAttribute("aria-pressed") === "true";

  if (isPressed) {
    // If the same button is clicked again, reset both
    clickedButton.setAttribute("aria-pressed", "false");
    localStorage.removeItem(articleKey);
  } else {
    // Otherwise, set the clicked button and save to localStorage
    clickedButton.setAttribute("aria-pressed", "true");
    otherButton.setAttribute("aria-pressed", "false");
    saveFeedback(choice);
  }
}

// Event listeners
likeButton && likeButton.addEventListener("click", () => handleFeedbackClick(likeButton, dislikeButton, "like"));
dislikeButton && dislikeButton.addEventListener("click", () => handleFeedbackClick(dislikeButton, likeButton, "dislike"));

// Load the saved feedback when the page loads
loadFeedback();


// SHARE BUTTONS

const shareButton = document.getElementById("share-toggle");
const shareLinks = document.getElementById("share-links");
const links = document.querySelectorAll(".share-link");
const shareLabel = document.getElementById("share-label");

// Generate shareable URLs
const pageUrl = encodeURIComponent(window.location.href);

const facebookShare = document.getElementById("share-facebook");
if (facebookShare) {
  facebookShare.href = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
}

const linkedinShare = document.getElementById("share-linkedin");
if (linkedinShare) {
  linkedinShare.href = `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`;
}

const twitterShare = document.getElementById("share-x");
if (twitterShare) {
  twitterShare.href = `https://twitter.com/intent/tweet?url=${pageUrl}`;
}

function toggleShare() {
  const isExpanded = shareButton.getAttribute("aria-expanded") === "true";

  // Toggle states
  shareButton.setAttribute("aria-expanded", !isExpanded);
  shareLinks.setAttribute("aria-hidden", isExpanded);

  if (!isExpanded) {
    // Animate links with staggered fade-in effect
    gsap.to(links, {
      opacity: 1,
      duration: 0.3,
      stagger: -0.1, // Each link fades in with a 0.2s delay
      ease: "power2.out",
    });
    gsap.to(shareLabel, { opacity: 0, duration: 0.4 });
  } else {
    // Hide links instantly when closing
    gsap.set(links, { opacity: 0 });
    gsap.to(shareLabel, { opacity: 1, duration: 0.4, delay: 0.2 });
  }
}

// Click event to toggle the links
shareButton && shareButton.addEventListener("click", toggleShare);


const slidingAccordions = document.querySelectorAll(".horizontalAccordion .staggerfromDown");

let lastHovered = document.querySelector(".horizontalAccordion .staggerfromDown.keep-open");

slidingAccordions.forEach((accordion) => {
  accordion.addEventListener("mouseenter", () => {
    if (lastHovered && lastHovered !== accordion) {
      lastHovered.classList.remove("keep-open");
    }
    accordion.classList.add("keep-open");
    lastHovered = accordion;
  });
});


//search button click
const searchForm = document.querySelector('.educational__form');
const searchButton = document.getElementById('search-button');
const form = document.querySelector('.educational__form');

if (searchButton) {
    searchButton.addEventListener('click', (event) => {
        form.submit();
    });
}